const personId = (person) => {
    if (!person) return '';
    if (typeof person === 'string') return person;
    return String(person._id || person.id || '');
};

const toParticipant = (person, role) => {
    if (!person || typeof person === 'string') return null;

    const id = personId(person);
    if (!id) return null;

    return {
        _id: person._id || person.id,
        firstName: person.firstName,
        lastName: person.lastName,
        email: person.email,
        avatarUrl: person.avatarUrl,
        typeUser: person.typeUser,
        matricula: person.matricula,
        participantRole: role,
        isOnline: Boolean(person.isOnline),
    };
};

/**
 * Usa la lista del chat si ya llegó; si no, arma profesor, moderador
 * y estudiantes con los mismos datos de la vista de tarjeta / lista.
 */
export const buildCourseParticipants = ({
    chatParticipants = [],
    course,
    students = [],
} = {}) => {
    if (Array.isArray(chatParticipants) && chatParticipants.length > 0) {
        return chatParticipants;
    }

    const list = [];
    const seen = new Set();

    const push = (person, role) => {
        const participant = toParticipant(person, role);
        if (!participant) return;

        const id = personId(participant);
        if (seen.has(id)) return;
        seen.add(id);
        list.push(participant);
    };

    push(course?.teacher, 'profesor');
    push(course?.moderator, 'moderador');
    (students || []).forEach((student) => push(student, 'estudiante'));

    return list;
};
